
import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseService } from '../../../../shared/services/base.service';
import { DialogService } from '../../../../shared/services/dialog.service';
import { Utility } from '../../../../common/utility';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { AppConstants } from '../../../../shared/constants/constants';
import { PermissionService } from '../../../../shared/services/permission.service';
import { GroupTemplateService } from './group-template.service';
import { GroupWaitingService } from '../group/group.service';

@Component({
  selector: 'add-to-group-template',
  templateUrl: 'add-to-group-template-popup.component.html',
  providers: [GroupTemplateService, GroupWaitingService]
})

export class AddToGroupTemplatePopupComponent implements OnInit {
  private groupTemplateForm: FormGroup;
  // private utility = Utility;
  private groupData = [];

  //public departureDate: Date = null;

  constructor(
    private utility: Utility,
    private formBuilder: FormBuilder,
    private groupWaitingService: GroupWaitingService,
    public dialogService: DialogService,
    private groupTemplateService: GroupTemplateService,
    public dialogRef: MdDialogRef<AddToGroupTemplatePopupComponent>,
    @Inject(MD_DIALOG_DATA) public data: any) {
    this.createForm();
  }

  ngOnInit() {
    this.getGroupNameList(null);
  }


  // onDepartureDateChange(dateText) {
  //   var departureDate = this.utility.convertDateToString(this.departureDate);
  //   this.getGroupNameList(departureDate);
  // }

  private getGroupNameList(departureDate) {
    // call API to get impersonated  user
    const param = {
      countryId: localStorage.getItem(AppConstants.localStorage.countryId),
      //departDate: departureDate,
      isDataEntry : true
    };
    this.groupTemplateService.getGroupTemplateList(param).subscribe
      (result => {
        if (result) {
          const data = result.json();
          this.groupData = data['list'];
        }
      });
  }

  createForm() {
    this.groupTemplateForm = this.formBuilder.group({
      groupId: [null, [Validators.required]],
      //departureDateDisplay: ['']
    });
  }

  onSubmit() {
    if (this.groupTemplateForm.valid) {
      // call API to add patient to group template
      this.groupWaitingService.addPatientToGroup(this.groupTemplateForm.controls.groupId.value, this.data.consultationId).subscribe(
        result => {
          if (result) {
            this.onCloseDialog(true);
          }
        });
    }
  }

  onCloseDialog(data = null) {
    this.dialogRef.close(data);
  }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/waiting-room/group-template/add-to-group-template-popup.component.ts